const a = {
  size: "caption",
  variant: "main",
  tag: "a"
};
export { a as linkDefaultProps };